import store from "../store";

const fillUserCafeteriasData = {
  install: (Vue) => {
    Vue.prototype.$fillUserCafeteriasData = (object) => {
      const me = store.getters["profile/me"];

      if (me.restrict_to_service_centers) {
        if (me.allowedServiceCenters.length > 0) {
          object.serviceCenter = {
            type: "service-centers",
            id: me.allowedServiceCenters[0].id,
          };
        }
      }

      if (me.restrict_to_establishments) {
        if (me.allowedEstablishments.length > 0) {
          object.establishment = {
            type: "establishments",
            id: me.allowedEstablishments[0].id,
          };
        }
      }

      if (me.restrict_to_cafeterias) {
        const cafeterias = me.allowedCafeterias || [];
        const establishmentId = object.establishment
          ? object.establishment.id
          : null;

        // The API derives the establishment from the cafeteria, so the two must
        // be prefilled as a coherent pair. Filling them independently used to
        // file the document under the cafeteria's school instead of the
        // establishment the user was assigned to, and made a second school
        // unreachable for anyone managing more than one.
        const cafeteria = establishmentId
          ? cafeterias.find((item) => item.establishment?.id === establishmentId)
          : cafeterias[0];

        if (cafeteria) {
          object.cafeteria = {
            type: "cafeterias",
            id: cafeteria.id,
          };
        }
      }

      return object;
    };
  },
};

export default fillUserCafeteriasData;
